// extracted by mini-css-extract-plugin
export var createdDate = "_hb-1";
export var divider = "_hb-2";
export var headerDivider = "_hb-3";
export var messagesCard = "_hb-0";
export var messagesContainer = "_hb-7";
export var messagesContainerWrapper = "_hb-4";
export var pointerCapturingButtonBoxes = "_hb-a";
export var showLeftPanelButton = "_hb-9";
export var showMoreButton = "_hb-c";
export var showMoreButtonContainer = "_hb-b";
export var summaryTitle = "_hb-6";
export var systemMessageCardWrapper = "_hb-d";
export var topButtons = "_hb-8";
export var withPadding = "_hb-5";